export interface tablaUsuariosApp {
    Usuarios: string,
    Password: string;
    Fecha: string;

    
  }
  
  export const TABLAUSUARIOSAPP: tablaUsuariosApp[] = [
    {
      Usuarios: "AFS123",
      Password: "123",
      Fecha: "2025-02-05 04:43:41",
    },

  ]